module.exports = __webpack_public_path__ + "static/media/41_tn.5ed3b1fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/41_tn.jpg
// module id = 529
// module chunks = 0